import script from "./SimpleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleButton.vue?vue&type=script&setup=true&lang=js"

import "./SimpleButton.vue?vue&type=style&index=0&id=445f181e&lang=scss"

const __exports__ = script;

export default __exports__